import * as React from "react";
import { Stack } from "@mui/material";
import {
  DateField,
  Datagrid,
  FilterButton,
  ListBase,
  ListToolbar,
  NumberField,
  NumberInput,
  Pagination,
  ReferenceInput,
  SelectInput,
  SortButton,
  TextField,
  Title,
  TopToolbar,
  useGetIdentity,
  useListContext,
} from "react-admin";

import { SkucmmsEmpty } from "./SkucmmsEmpty";

const optionCompaniesRenderer = (choice: any) =>
  `${choice.id} - ${choice.nome_reduzido}`;

const skucmmsFilters = [
  <NumberInput source="codigo_sku" label="Cód. SKU" alwaysOn />,
  <ReferenceInput
    source="id_empresa"
    reference="companies"
    perPage={100}
    sort={{ field: "id", order: "ASC" }}
    label="Empresa"
    filter={{ todas: true }}
  >
    <SelectInput
      optionText={optionCompaniesRenderer}
      label="Empresa"
      sx={{ width: "250px" }}
    />
  </ReferenceInput>,
];

export const SkucmmsList = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;

  return (
    <ListBase perPage={25} sort={{ field: "id", order: "ASC" }}>
      <SkucmmsListLayout />
    </ListBase>
  );
};

const SkucmmsListLayout = () => {
  const { data, isPending } = useListContext();
  const { identity } = useGetIdentity();

  if (!identity || isPending) return null;

  return (
    <Stack sx={{ width: "100%" }}>
      <Title title="CMM por loja" />
      <ListToolbar filters={skucmmsFilters} actions={<SkucmmsListActions />} />

      {data?.length ? (
        <>
          <Datagrid bulkActionButtons={false}>
            <NumberField
              source="id"
              label="ID"
              options={{ useGrouping: false }}
            />
            <TextField source="sigla_loja" label="Loja" />
            <NumberField
              source="codigo_sku"
              label="SKU"
              options={{ useGrouping: false }}
            />
            <NumberField
              source="dias_estoq"
              label="Dias Estoq"
              options={{ useGrouping: false }}
            />
            <NumberField
              source="qtd_natural"
              label="CMM Natural"
              options={{ useGrouping: false }}
            />
            <NumberField
              source="quant_mes"
              label="CMM"
              options={{ useGrouping: false }}
            />

            <NumberField
              source="ticket_mes"
              label="Ticket/Mês"
              options={{
                style: "currency",
                currency: "BRL",
              }}
            />
            <NumberField
              source="valor_mes"
              label="Valor/Mês"
              options={{
                style: "currency",
                currency: "BRL",
              }}
            />

            <NumberField source="proj_efet" label="Proj Efet" />
            <NumberField source="sazo_efet" label="Sazo Efet" />
            <TextField source="expo" label="Expo" />
            <NumberField source="cmmf_quant" label="CMMF Quant" />
            <DateField source="cmmf_validade" label="CMMF Validade" />
          </Datagrid>
          <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
        </>
      ) : (
        <SkucmmsEmpty />
      )}
    </Stack>
  );
};

const SkucmmsListActions = () => (
  <TopToolbar>
    <FilterButton disableSaveQuery />
    {/* <SortButton
      fields={[
        "id",
        "sigla_loja",
        "dias_estoq",
        "quant_mes",
        "ticket_mes",
        "valor_mes",
        "qtd_natural",
        "sazo_efet",
        "codigo_sku",
        "expo",
        "cmmf_quant",
        "cmmf_validade",
      ]}
    /> */}
  </TopToolbar>
);
